import React from 'react';
import { Link } from 'react-router-dom';

// 1. Import your specific .jpeg images here
import img1 from "../../../assets/img/portfolio/portfolio-col4-1.jpeg";
import img2 from "../../../assets/img/portfolio/portfolio-col4-2.jpeg";
import img3 from "../../../assets/img/portfolio/portfolio-col4-3.jpeg";
import img4 from "../../../assets/img/portfolio/portfolio-col4-4.jpeg";
import img5 from "../../../assets/img/portfolio/portfolio-col4-5.jpeg";
import img6 from "../../../assets/img/portfolio/portfolio-col4-6.jpeg";
import img7 from "../../../assets/img/portfolio/portfolio-col4-7.jpeg";
import img8 from "../../../assets/img/portfolio/portfolio-col4-8.jpeg";

// 2. Create the custom data array for this 4-column page
const customPortfolioData = [
    { id: "road-construction", image: img1, title: "Road Construction", subtitle: "Civil Work" },
    { id: "drainage-system", image: img2, title: "Space System", subtitle: "Infrastructure" },
    { id: "pipeline-setup", image: img3, title: "Pipeline Setup", subtitle: "Public Utility" },
    { id: "rcc-road", image: img4, title: "RCC Road", subtitle: "Civil Work" },
    { id: "irrigation-line", image: img5, title: "Planning", subtitle: "Agriculture" },
    { id: "damar-road", image: img6, title: "Damar Road", subtitle: "Infrastructure" },
    { id: "beautification", image: img7, title: "Beautification", subtitle: "Urban Development" },
    { id: "renovation", image: img8, title: "Renovation", subtitle: "Public Utility" }
];

const FourColumns = () => {
    return (
        <div className="four__columns section-padding-three">
            <div className="container">
                <div className="row">
                    {/* 3. Map through your custom array instead of the default one */}
                    {customPortfolioData?.map((data, id) => (
                        <div className="col-lg-3 col-md-6 mt-25" key={id}>
                            <div className="portfolio__four-item">
                                <Link to={`/portfolio/${data.id}`}><i className="flaticon flaticon-right-up"></i></Link>
                                
                                {/* Image crop styling added for a uniform grid */}
                                <img src={data.image} alt={data.title} style={{ width: '100%', height: '250px', objectFit: 'cover' }} />
                                
                                <div className="portfolio__four-item-content">
                                    <span>{data.subtitle}</span>
                                    <h5><Link to={`/portfolio/${data.id}`}>{data.title}</Link></h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FourColumns;